import { faCheck, faCopy, faRotateRight, faThumbsDown, faThumbsUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';

import { useCopyToClipboard } from '@spacefill/uikit/src/utils/useCopyToClipboard';

const stripMarkdownLinks = (text) => text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

export const AssistantMessageActions = ({
    content,
    question,
    onReplay,
    msgIndex,
    ratings,
    onRate,
    requiresConfirmation,
    sql,
    onConfirmSql,
    t,
}) => {
    const { copy, copied } = useCopyToClipboard();

    return (
        <div className='flex gap-1.5'>
            {sql && (
                <>
                    {['up', 'down'].map((dir) => (
                        <button
                            key={dir}
                            type='button'
                            onClick={() => onRate(msgIndex, dir)}
                            disabled={ratings[msgIndex] != null}
                            title={dir === 'up' ? t('Good answer') : t('Bad answer')}
                            className={clsx(
                                'rounded-lg border px-2 py-1 text-[13px] leading-none transition-all',
                                ratings[msgIndex] === dir
                                    ? dir === 'up'
                                        ? 'border-green-300 bg-green-100'
                                        : 'border-red-300 bg-red-100'
                                    : 'border-gray-200 bg-gray-50',
                                ratings[msgIndex] != null ? 'cursor-default' : 'cursor-pointer',
                                ratings[msgIndex] != null && ratings[msgIndex] !== dir ? 'opacity-45' : 'opacity-100'
                            )}
                        >
                            {dir === 'up' ? (
                                <FontAwesomeIcon
                                    icon={faThumbsUp}
                                    className='text-lime-500'
                                />
                            ) : (
                                <FontAwesomeIcon
                                    icon={faThumbsDown}
                                    className='text-red-500'
                                />
                            )}
                        </button>
                    ))}
                    {requiresConfirmation && (
                        <button
                            type='button'
                            onClick={() => onConfirmSql(sql)}
                            className='cursor-pointer rounded-lg border border-blue-200 bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-700'
                        >
                            {t('Confirm')}
                        </button>
                    )}
                </>
            )}
            <button
                type='button'
                onClick={() => copy(stripMarkdownLinks(content))}
                title={copied ? t('Copied!') : t('Copy')}
                className={clsx(
                    'cursor-pointer rounded-lg border px-2 py-1 text-[13px] leading-none transition-all',
                    copied ? 'border-lime-300 bg-lime-100' : 'border-gray-200 bg-gray-50'
                )}
            >
                <FontAwesomeIcon
                    icon={copied ? faCheck : faCopy}
                    className={copied ? 'text-lime-600' : 'text-gray-500'}
                />
            </button>
            {question && (
                <button
                    type='button'
                    onClick={() => onReplay(question)}
                    title={t('Replay')}
                    className='cursor-pointer rounded-lg border border-gray-200 bg-gray-50 px-2 py-1 text-[13px] leading-none transition-all'
                >
                    <FontAwesomeIcon
                        icon={faRotateRight}
                        className='text-gray-500'
                    />
                </button>
            )}
        </div>
    );
};
